"use strict";export const UNIQUE_PROPERTIES_PER_SIGNER={alchemy:"signerType",ethers:"provider",viem:"transport"};
